let btn = $('.show-more-btn');
let container = $('.show-more-content');

export function hideContent() {
  [...container].forEach((element) => {
    let itemToShow = $(element).data('to-show');
    let children = [...$(element).children()];
    let id = $(element).attr('id');

    if (children[itemToShow - 1]) {
      let childItem =  $(children[itemToShow - 1]); 
      let contentHeight = Math.round(childItem.position().top + childItem.outerHeight() - $(element).position().top);

      $(element).height(contentHeight);
    } else {
      $(`.show-more-btn[data-shown="${id}"]`).hide();
    }
  });
}

export function showContent() {
  btn.on('click', function (event) {
    let id = $(this).data('shown');
    let parent = $(`.show-more-content#${id}`);

    event.preventDefault();
    parent.toggleClass('showed');
    $(this).text(parent.hasClass('showed') ? 'Show Less' : 'Show More');
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/showMore.js